export default "__VITE_ASSET__ef2c1055__"